import {Injectable} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {EnumsService} from '../../../services/enums.service';
import {UrlValidatorService} from '../../../services/url-validator.service';
import {ActivatedRouteSnapshot, Params, Router} from '@angular/router';
import {UrlTermsSymbolsEnum} from '../../../enums/SeoEnums';
import {AllowedParamGroup} from '../../../types/AllowedParamGroup';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {RedirectService} from '../../../services/redirect.service';
import {RoutesQueryParamsEnum} from '../../../enums/RoutesEnums';

@Injectable()
export class NativesUrlResolverService {
  public page = 1;
  public tag: number;
  public tagName: string;
  public pageWasSet: boolean = false;

  private urlQueryParamsProcessorsMap: Array<Function> = [];
  private total: number;

  constructor(
    private tools: ToolsService,
    private enumsService: EnumsService,
    private urlValidator: UrlValidatorService,
    private urlBuilder: UrlBuilderService,
    private router: Router,
    private redirect: RedirectService
  ) {
    this.createUrlQueryParamsProcessorsMap();
  }

  public resetState(): void {
    this.page = 1;
    this.tag = null;
    this.tagName = null;
    this.pageWasSet = false;
  }

  public cleanUpUrl(snapshot: ActivatedRouteSnapshot): boolean {
    const allowedQueryParams: string[] = [
      UrlTermsSymbolsEnum.PAGE,
      RoutesQueryParamsEnum.GCLID,
      RoutesQueryParamsEnum.UTM_CAMPAIGN,
      RoutesQueryParamsEnum.UTM_SOURCE,
      RoutesQueryParamsEnum.UTM_MEDIUM,
      RoutesQueryParamsEnum.UTM_SIZE,
      RoutesQueryParamsEnum.UTM_TERM,
      RoutesQueryParamsEnum.UTM_CONTENT,
      RoutesQueryParamsEnum.FBCLID,
    ];

    const allowedParamsGroups: AllowedParamGroup[] = [];
    allowedParamsGroups.push({
      params: [
        {
          type: 'id-slug',
          value: null,
        },
      ],
    });

    const routingBase: string[] = this.urlBuilder.CreateNativesRouterLink();
    return this.urlValidator.cleanUpUrlAndRedirect(
      snapshot,
      routingBase,
      allowedParamsGroups,
      allowedQueryParams
    );
  }

  public conditionalRedirectBadPage(): boolean {
    if (this.pageWasSet) {
      this.redirect.redirect(this.urlBuilder.CreateNativesRouterLink());
      return true;
    }
    return false;
  }

  public conditionalRedirectEmptyResultsPage(): boolean {
    if (!this.tools.isNil(this.tag) && this.total === 0) {
      this.redirect.redirect(this.urlBuilder.CreateNativesRouterLink());
      return true;
    }
    return false;
  }

  public processRouteQueryParams(params: Params): boolean {
    this.pageWasSet = false;
    const paramsKeys: string[] = Object.keys(params).filter(
      (value) => typeof value === 'string'
    ) as string[];
    let wasRedirected: boolean = false;
    paramsKeys.forEach((key, index) => {
      if (!this.tools.isNil(this.urlQueryParamsProcessorsMap[key])) {
        this.urlQueryParamsProcessorsMap[key](params[key]);
        if (key === UrlTermsSymbolsEnum.PAGE) {
          this.pageWasSet = true;
          if (params[key] === '1') {
            const isRedirect: boolean = this.conditionalRedirectBadPage();
            if (wasRedirected === false) {
              wasRedirected = isRedirect;
            }
          }
        }
      }
    });
    if (this.pageWasSet === false) {
      this.page = 1;
    }
    return wasRedirected;
  }

  public processRouteParams(params: Params): void {
    if (!this.tools.isNil(params.id)) {
      this.tag = parseInt(params.id, 10);
    }

    if (!this.tools.isNil(params.tag)) {
      this.tagName = params.tag;
    }
  }

  public setTotal(total: number): void {
    this.total = total;
  }

  private createUrlQueryParamsProcessorsMap() {
    this.urlQueryParamsProcessorsMap[UrlTermsSymbolsEnum.PAGE] = (
      page: number
    ) => (this.page = page);
  }
}
